import {KeyboardEventHandler, useRef} from 'react';
import css from './otp.module.scss';
import {OTPProps} from './otp.types';

export const OTP = (props: OTPProps): JSX.Element => {
	const refs = useRef<HTMLInputElement[]>([]);

	const addInputRefToRefs = (ref: HTMLInputElement): void => {
		refs.current.push(ref);
	};

	/** @desc Focuses on the next input and in case of last input, goes out of focus */
	const setFocus = (index: number) => {
		if (index <= refs.current.length - 2) {
			refs.current[index + 1].focus();
		} else {
			refs.current[index].blur();
		}
	};

	const remove = (index: number) => {
		refs.current[index].value = '';
		index > 0 && refs.current[index - 1].focus();
		return;
	};

	// TODO: guard against non-numeric values
	const onKeyDown =
		(index: number): KeyboardEventHandler<HTMLInputElement> =>
			(ev) => {
				ev.preventDefault();
				if (ev.key === 'Backspace') {
					remove(index);
					return;
				}
				refs.current[index].value = ev.key;
				setFocus(index);
				emitValue();
			};

	const emitValue = () => {
		const value = refs.current
			.map(({value}) => value)
			.filter((item) => item !== '')
			.join('');

		const valueHasCorrectLength = value.length === refs.current.length;
		valueHasCorrectLength && props.onFilled(value);
	};

	const setClasses = () => {
		if (props.hasError) {
			return {className: `${css.input} ${css.error}`};
		}
		return {className: css.input};
	};

	return (
		<div className={css.container}>
			<input pattern="\d*" ref={addInputRefToRefs} onKeyDown={onKeyDown(0)} {...setClasses()} maxLength={1} />
			<input pattern="\d*" ref={addInputRefToRefs} onKeyDown={onKeyDown(1)} {...setClasses()} maxLength={1} />
			<input pattern="\d*" ref={addInputRefToRefs} onKeyDown={onKeyDown(2)} {...setClasses()} maxLength={1} />
			<input pattern="\d*" ref={addInputRefToRefs} onKeyDown={onKeyDown(3)} {...setClasses()} maxLength={1} />
		</div>
	);
};
